import { ContentBlockGrid } from "@gift/ui";

export const ContentBlock_4: React.FC = () => (
    <ContentBlockGrid
        headline="Hosté si vyberou finanční dárky, které sednou jejich vkusu i peněžence"
        description="Toužíte po exotických líbánkách? Rozdělte je na letenku, potápění s delfíny nebo romantickou večeři při západu slunce. Nežádáte o zaslání peněz nebo neosobní obálku, ale o finanční dárek, který splní velké přání."
        backgroundColors={["#E4E0EB", "#f6f3ea", "#EFF5F7"]}
    />
);
